import React, { useRef } from 'react';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { useUser } from '../../../../../redux/reducer/user';
import { useGiftChooseShowAnimation } from '../../model/hooks/useGiftChooseShowAnimation';
import { useTranslation } from '../../../../../translations';
import { ACTIVE, BUY, CHOOSE, HAS } from '../../constants/types';
import { useFeatureToggle } from '../../../../../hooks/useFeatureToggle';

export default function Item({
  active,
  id,
  preview_image,
  isGifted,
  index,
  cost,
  giftCost,
  beautiesCost,
  setActiveShopItem,
}) {
  const { profile: { money, gacha_event_cash, beauties } = {} } = useUser();
  const gameTamagotchiBeauties = useFeatureToggle('gameTamagotchiBeauties');
  const secondCurrencyPrice = gameTamagotchiBeauties ? beautiesCost : giftCost;
  const totalPrice = cost || secondCurrencyPrice;
  const itemType = isGifted ? HAS : active === id ? ACTIVE : totalPrice ? BUY : CHOOSE;
  const secondCurrencyBalance = gameTamagotchiBeauties ? beauties : gacha_event_cash;
  const isCoinPrice = !!totalPrice && totalPrice === cost;
  const isSecondCurrencyPrice = !!totalPrice && !isCoinPrice && totalPrice === secondCurrencyPrice;
  const isInsufficientSecondCurrency =
    typeof secondCurrencyBalance !== 'number' || secondCurrencyPrice > secondCurrencyBalance;
  const isDisabled =
    itemType === BUY && (isCoinPrice ? cost > money : isSecondCurrencyPrice ? isInsufficientSecondCurrency : false);

  const itemRef = useRef(null);
  const imageRef = useRef(null);

  const { t } = useTranslation();
  const onClick = () => {
    ({
      buy: () => setActiveShopItem(id),
      choose: () => setActiveShopItem(id),
      active: () => setActiveShopItem(null),
    })[itemType]?.();
  };

  useGiftChooseShowAnimation({ index, itemRef, imageRef });

  return (
    <div
      className={classNames('gift-choose__item', { ['gift-choose__item_inactive']: itemType === HAS })}
      ref={itemRef}
    >
      <div className={classNames('gift-choose__item-content')}>
        <div className={'gift-choose__item-image'} ref={imageRef}>
          <img src={preview_image} alt={''} />
        </div>
        <CustomButton
          text={{ [HAS]: t('other.have'), [CHOOSE]: t('other.select') }[itemType] ?? ''}
          {...(itemType === BUY && isCoinPrice && { coins: true })}
          {...(itemType === BUY &&
            isSecondCurrencyPrice &&
            (gameTamagotchiBeauties ? { beauties: true } : { gifts: true }))}
          icon={itemType === ACTIVE && 'equipped'}
          {...(totalPrice && itemType === BUY && { count: totalPrice })}
          {...(isDisabled && { disabled: true })}
          className={classNames('gift-choose__item-button button_my-gift', {
            'button_my-gift-unequip': itemType === ACTIVE,
            'button_my-gift-equip': itemType !== ACTIVE,
            'button_green button_gift-choose-price': totalPrice && itemType === BUY,
          })}
          onClick={onClick}
        />
      </div>
    </div>
  );
}
